import React from 'react'
import styled from 'styled-components'

import Select from 'react-select'

import { FONTS } from '../../constants'

export const SearchSelect = (props) => {
  return (
    <Root width={ props.width } height={ props.height }>
      <SelectField
        styles={ customStyles }
        placeholder={ props.placeholder || 'Select Here' }
        menuPlacement={ props.menuPlacement || 'auto' }
        menuPosition={ props.menuPosition || 'fixed' }
        { ...props }
      />
    </Root>
  )
}

const customStyles = {
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'rgba(0, 0, 0, 0.04)' : '#FFFFFF',
    color: '#333',
    ':active': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  }),
  menu: (base, state) => ({
    ...base,
    background: state.isDisabled ? '#EAEAEA' : '#FFFFFF',
    padding: 0,
  }),
  container: base => ({
    ...base,
    height: '100%',
    minHeight: '100%',
  }),
  valueContainer: (base) => ({
    ...base,
    height: '100%',
    minHeight: '100%',
  }),
  control: (base, state) => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    padding: 0,
    border: 'none',
    background: state.isDisabled ? '#EAEAEA' : '#FFFFFF',
    fontFamily: FONTS.GOTHAM,
    fontSize: FONTS.SMALL_SIZE,
    boxShadow: 'none',
  }),
  dropdownIndicator: base => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    padding: '4px 6px',
  }),
  indicatorSeparator: base => ({
    ...base,
    display: 'none',
  }),
  placeholder: base => ({
    ...base,
    height: '100%',
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    fontSize: FONTS.SMALL_SIZE,
    color: '#C4C4C4',
    whiteSpace: 'nowrap',
  }),
  input: base => ({
    ...base,
    margin: '0 2px',
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#808080' : '#333333',
    fontSize: FONTS.SMALL_SIZE,
  }),
}

const Root = styled.div`
    width: ${p => p.width || '100%'};
    height: ${p => p.height || '30px'};
`

const SelectField = styled(Select)`
    width: 100%;
    height: 100%;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #333333;
    border: 1px solid #C4C4C4;
    border-radius: 4px;

    ${p => p.invalid && `
      border: 1px solid #dc3545;
    `}

    :focus {
      outline: none;
      box-shadow: none;
      border: 1px solid #C4C4C4;
    }

    :disabled {
      background: #EAEAEA;
      color: #C4C4C4;
    }
`



// WEBPACK FOOTER //
// ./src/components/input/search-select.js